import React from 'react'

export default function ConsumerPortal () {
  return (
    <div>
      ConsumerPortal
    </div>
  )
}
